import { PendingTeamsSortOption } from './sortOptions';
/*
 * Although they have the similar names, the purpose of this type is different
 * from the one used by PageHeaderSort.
 *
 * ClassicSortOption provides the data necessary for the classic data
 * model to sort and item list for a given sort option name.
 *
 * The SortOption type used in PageHeaderSort is strictly the data needed to display
 * the option in the Sort component.
 *
 *
 * While the dashboard is still using the classic data model, the individual
 * page components should not have any knowledge of the ClassicSortOption. They
 * are aware of the various option names (e.g. the PendingTeamsSortOption enum),
 * and then provide PageHeaderSort an object with those options and display info
 * for them.
 *
 * The adapter layer can then take the option names returned via callbacks when
 * a user clicks a sort option, use it to get the ClassicSortOption associated with it,
 * and pass those values down to the class ItemList.
 */
export interface ClassicSortOption {
  // Unique identifier for this sort option
  name: string;

  // The field this option sorts by
  // (this field is present due to how item lists
  // were sorted in the classic dashboard. It's existence
  // should be questioned when the dashboard moves to GraphQL)
  sortField: string;

  // The order this option sorts by
  // (this field is present due to how item lists
  // were sorted in the classic dashboard. It's existence
  // should be questioned when the dashboard moves to GraphQL)
  sortOrder: string;
}

export const PendingTeamsClassicSortOptions: Record<
  PendingTeamsSortOption,
  ClassicSortOption
> = {
  [PendingTeamsSortOption.AZ]: {
    name: PendingTeamsSortOption.AZ,
    sortField: 'displayName',
    sortOrder: 'ascending',
  },
  [PendingTeamsSortOption.ZA]: {
    name: PendingTeamsSortOption.ZA,
    sortField: 'displayName',
    sortOrder: 'descending',
  },
  [PendingTeamsSortOption.LeastRecentlyCreated]: {
    name: PendingTeamsSortOption.LeastRecentlyCreated,
    sortField: 'dateCreated',
    sortOrder: 'ascending',
  },
  [PendingTeamsSortOption.MostRecentlyCreated]: {
    name: PendingTeamsSortOption.MostRecentlyCreated,
    sortField: 'dateCreated',
    sortOrder: 'descending',
  },
};
